export const DATA_CLASSIFICATION_ROLE = {
    pepsicoConfidential: 'pepsico confidential',
    pepsicoRestricted: 'pepsico restricted',
    pepsicoInternal: 'pepsico internal',
    pepsicoPublic: 'pepsico public',
};

export const ROLE_TO_SHOW = [DATA_CLASSIFICATION_ROLE.pepsicoConfidential, DATA_CLASSIFICATION_ROLE.pepsicoRestricted];
export const SIGNATURE_ROLE_TO_SHOW = [DATA_CLASSIFICATION_ROLE.pepsicoConfidential];
export const RESTRICTED_ROLE_TO_SHOW = [DATA_CLASSIFICATION_ROLE.pepsicoRestricted];
export const EXCLUDE_ROLE_TO_SHOW = [
    DATA_CLASSIFICATION_ROLE.pepsicoRestricted,
    DATA_CLASSIFICATION_ROLE.pepsicoInternal,
    DATA_CLASSIFICATION_ROLE.pepsicoConfidential,
];

export const SAMLRequestType = 'SAML 2.0';
export const OIDCRequestType = 'OIDC - OpenID Connect';
export const MACHINERequestType = 'OIDC OAUTH2.0 - Machine2Machine(API Service)';

export const HARD_CODED_GPIDS = [
    {
        gpid: '80970694',
        name: 'Venu Mandava',
    },
    {
        gpid: '80231631',
        name: 'Sreedhar Reddy Siriganna Gari',
    },
];

export const SSO_TITLE = 'Add SSO Okta for Application';

export default {};
